import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const VOLUNTEERS_VOLUNTEER_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/volunteers',
        iconClass: 'fas fa-hands-helping',
        name: '::Menu:Volunteers',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.Volunteers',
      },
    ]);
  };
}
